import { render, staticRenderFns } from "./ActivityTotalScoreDetail.vue?vue&type=template&id=085ca188&"
import script from "./ActivityTotalScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityTotalScoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports